var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionTooltipNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.88888 0.111084C2.2 0.111084 0 2.31108 0 4.99998C0 7.68886 2.2 9.88889 4.88888 9.88889C7.57778 9.88889 9.77774 7.68886 9.77774 4.99998C9.77774 2.31108 7.57778 0.111084 4.88888 0.111084ZM4.88888 8.05553C4.52222 8.05553 4.27778 7.81108 4.27778 7.44441C4.27778 7.07775 4.52222 6.83331 4.88888 6.83331C5.25555 6.83331 5.5 7.07775 5.5 7.44441C5.5 7.81108 5.25555 8.05553 4.88888 8.05553ZM5.80555 5.24441C5.5 5.42775 5.5 5.48886 5.5 5.61108V6.22219H4.27778V5.61108C4.27778 4.81664 4.76667 4.44998 5.13333 4.20553C5.43888 4.02219 5.5 3.96108 5.5 3.77775C5.5 3.41108 5.25555 3.16664 4.88888 3.16664C4.64445 3.16664 4.46111 3.28886 4.33888 3.47219L4.03333 4.02219L2.99445 3.41108L3.3 2.86108C3.60555 2.31108 4.21667 1.94441 4.88888 1.94441C5.92778 1.94441 6.72222 2.73886 6.72222 3.77775C6.72222 4.63331 6.17222 4.99998 5.80555 5.24441Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTooltipNew);
export default __webpack_public_path__ + "static/media/question-tooltip-new.fbcb5c5a57ee00b6724a070d58cfd659.svg";
export { ForwardRef as ReactComponent };